export const formatCollectionTime = (
  isoStartDate: string,
  isoEndDate: string
) => {
  const startDate = new Date(isoStartDate);
  const endDate = new Date(isoEndDate);

  const startTime = new Date(startDate).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const endTime = new Date(endDate).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${startTime}-${endTime}`;
};
